import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./contexts/I18nContext";
import { CartProvider } from "./contexts/CartContext";
import { CompositionProvider } from "./contexts/CompositionContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Gallery from "./pages/Gallery";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import CGV from "./pages/CGV";
import Admin from "./pages/Admin";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <I18nProvider>
      <CartProvider>
        <CompositionProvider>
          <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/produits" element={<Catalog />} />
              <Route path="/produits/:category" element={<Catalog />} />
              <Route path="/produits/:category/:slug" element={<ProductDetail />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/panier" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/paiement/succes" element={<PaymentSuccess />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="/conditions-generales" element={<CGV />} />
            </Route>
            {/* Page admin hors Layout (pas de header/footer) */}
            <Route path="/admin" element={<Admin />} />
          </Routes>
          {/* Bannière consentement cookies — globale, hors Layout pour visible partout */}
          <CookieConsent />
        </BrowserRouter>
        </CompositionProvider>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid #39FF14",
              color: "#fff",
              fontFamily: "Rajdhani, sans-serif",
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              borderRadius: 0,
            },
          }}
        />
      </CartProvider>
    </I18nProvider>
  );
}

export default App;
